import usePageActionPermission from "shared/hooks/access/usePageActionPermission";
import PropTypes from "prop-types";

const ActionPermissionGuard = ({
    code,
    customPath,
    children = <></>,
    fallback = <></>,
}) => {
    const hasPermission = usePageActionPermission(code, customPath);

    return hasPermission ? children : fallback;
};

ActionPermissionGuard.propTypes = {
    code: PropTypes.string,
    customPath: PropTypes.string,
    children: PropTypes.node,
    fallback: PropTypes.node,
};

export default ActionPermissionGuard;
